import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {ActionMethod, ActionOrigin, RequestV2StatusType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateOrUpdateServerProcessTask, CreateTaskForNewProcess} from 'processes/dao/ProcessManagementDAO';
import EntityStore from 'stores/EntityStore';
import {patchJSONPromise, postJSONPromise} from 'util/Net';
import {withLoadingScreen} from 'util/Promises';

import {RequestV2SubmissionGraphQL} from '../../../../graphql-fragments/processes/requests-v2/__generated/RequestV2SubmissionGraphQL';

export interface CreateRequestV2SubmissionParams {
  folderId: string;
  name?: string;
  requestV2DefinitionId: string;
  actionOrigin: ActionOrigin;
  actionMethod: ActionMethod;
  studyIds: Array<string>;
  watcherIds: Array<string>;
  taskSpecs?: Array<CreateOrUpdateServerProcessTask | CreateTaskForNewProcess>;
}

export interface CreateRequestV2SubmissionResponse {
  requestV2Submissions: Array<RequestV2SubmissionGraphQL>;
}

export function requestV2SubmissionPageUrl(apiId: string): string {
  return `/${EntityStore.currentUser().url_identifier}/requests-v2/${apiId}`;
}

export function createRequestV2Submission(
  requestV2Submission: CreateRequestV2SubmissionParams,
  message?: string,
  showLoadingScreen: boolean = true
): Promise<CreateRequestV2SubmissionResponse> {
  const creates = [requestV2Submission];
  const promise = postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.REQUEST_V2_SUBMISSION),
    data: {creates},
  });
  if (showLoadingScreen) {
    return withLoadingScreen(promise, message || 'Creating request...');
  }
  return promise;
}

export interface UpdateRequestV2SubmissionParams extends UpdateArchivableParams {
  id: string;
  name?: string;
  status?: RequestV2StatusType;
  watcherIds?: Array<string>;
  actionOrigin: ActionOrigin;
  actionMethod: ActionMethod;
  studyIds?: Array<string>;
}

export interface UpdateRequestV2SubmissionResponse {
  requestV2Submissions: Array<RequestV2SubmissionGraphQL>;
}

export function updateRequestV2Submission(
  requestV2Submission: UpdateRequestV2SubmissionParams
): Promise<UpdateRequestV2SubmissionResponse> {
  const updates = [requestV2Submission];
  return patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.REQUEST_V2_SUBMISSION),
    data: {updates},
  });
}
